<!--销售订单 待确认订单列表 -->
<template>
  <div style="width: 100%; height: 100%">
    <el-row>
      <el-form size="medium" :inline="true" class="demo-form-inline" style="padding-top: 0; margin-top: 0">
        <el-form-item label="副仓：" v-if="subWarehouseList && subWarehouseList.length > 1 && isTcCus">
          <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择副仓" clearable multiple collapse-tags
            style="width: 200px;">
            <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户：" v-if="isTcCus">
          <el-select filterable v-model="searchForm.TC_COMPANY" placeholder="请选择" @change="queryPROJECT()" clearable>
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" v-if="isTcCus">
          <el-select filterable v-model="searchForm.PROJECT" @change="__querydkList()" placeholder="请选择" clearable
            multiple collapse-tags>
            <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
              <span style="float: left">{{ item.PROJECT_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：" v-if="isTcCus">
          <el-select filterable v-model="searchForm.dkName" placeholder="请选择档口" style="width: 100%" clearable>
            <el-option v-for="item in dkList" :key="item.value" :label="item.NAME" :value="item.ID">
              <span style="float: left">{{ item.NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商：" v-if="isSupplierCus">
          <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable>
            <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              <span style="float: left">{{ item.AB_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="送货日期：">
          <el-date-picker v-model="searchForm.SEND_DAY" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单类型：">
          <el-select filterable v-model="searchForm.ADDED_ORDER" placeholder="请选择" clearable>
            <el-option v-for="item in addedOrderTypeList" :key="item.value" :label="item.NAME" :value="item.ID" />
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态：" v-if="[1, 2].includes(Number(currentOrderFlag))">
          <el-select filterable v-model="searchForm.STATUS" placeholder="请选择" clearable>
            <el-option v-for="item in stateList" :key="item.value" :label="item.NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="配送类型：" v-if="[0, 1, 2].includes(Number(currentOrderFlag))">
          <el-select multiple filterable v-model="searchForm.配送类型" placeholder="请选择配送类型" @change="handleSearch"
            clearable>
            <el-option v-for="item in 团餐客户配送类型列表" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品名称：">
          <el-input v-model="searchForm.PRODUCT_NAME"></el-input>
        </el-form-item>
        <el-form-item label="订单ID：">
          <el-input v-model="searchForm.ORDER_ID"></el-input>
        </el-form-item>
        <el-form-item label="日期范围：">
          <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="订单备注：" v-if="isTcCus">
          <el-input v-model="searchForm.ORDER_LIST_COMMENT" placeholder="请输入订单备注" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loadSearch">筛选</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain @click="exportAllConfirmOrder" v-if="fun_dic[1000301]">
            导出全部订单
          </el-button>
          <el-button type="primary" plain @click="openExportPDF" v-if="isTcCus && fun_dic[1000302]">
            导出PDF
          </el-button>
          <el-button type="primary" plain @click="exportMergeOrder" v-if="isTcCus && fun_dic[1000303]">
            导出合并PDF订单
          </el-button>
          <tooltip-button :disabled="Boolean(searchForm.配送类型.toString() == '2' && checkedArray.length)" v-if="isSelf"
            :tipContent="批量确认到历史提示" buttonType="primary" buttonPlain buttonText="批量确认到历史" @click="batchChangeToHistory">
          </tooltip-button>
          <tooltip-button :disabled="Boolean(checkedArray.length)" v-if="fun_dic[1000305]" tipContent="请勾选要标记的订单"
            buttonType="primary" buttonPlain buttonText="标记为过滤关账" @click="setFinancialClosingIgnore">
          </tooltip-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-tabs type="border-card" @tab-click="handleSearch" v-model="currentOrderFlag">
        <el-tab-pane label="待供应商确认">
          <el-col :span="24">
            <el-table :data="tableData" ref="table" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ORDER_ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="195"></el-table-column>
              <el-table-column label="是否过滤关账" v-if="fun_dic[1000305]">
                <template slot-scope="scope">{{ scope.row.FINANCIAL_CLOSING_IGNORE ? '是' : '否' }}</template>
              </el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="100"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100" sortable></el-table-column>
              <el-table-column prop="ORDER_STATUS" label="状态" min-width="180"></el-table-column>
              <el-table-column prop="ADDED_ORDER" label="订单类型" min-width="100"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="280">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="openDetail(scope.row, 1)">查看
                  </el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="singlePDF(scope.row)">导出PDF
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-tab-pane>
        <!-- --------------------------------自录订单------------------------------------------- -->
        <el-tab-pane label="自录订单确认">
          <el-col :span="24">
            <el-table :data="tableData" ref="table" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ORDER_ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column label="是否过滤关账" v-if="fun_dic[1000305]">
                <template slot-scope="scope">{{ scope.row.FINANCIAL_CLOSING_IGNORE ? '是' : '否' }}</template>
              </el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="95"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column label="客户类型">
                <template slot-scope="scope">
                  <el-tag>{{ showOrderType[scope.row.TC_STATUS - 1] }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_STATUS" label="状态" min-width="180"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="100"></el-table-column>
              <el-table-column prop="ADDED_ORDER" label="订单类型" min-width="100"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" min-width="185">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="update(scope.row)">验收</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单</el-button>
                  <el-button type="text" size="small" @click="singlePDF(scope.row)">导出PDF</el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质</el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告</el-button>
                  <el-button type="text" size="small" @click="openDateDia(scope.row)"
                    v-if="scope.row.TC_STATUS == 2">修改日期</el-button>
                  <el-button type="text" size="small" @click="修改客户(scope.row)"
                    v-if="Number(scope.row.TC_STATUS) == 2 && fun_dic[1000304]">
                    修改客户
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="待项目点确认">
          <el-col :span="24">
            <el-table :data="tableData" ref="table" border stripe :summary-method="getSummaries" show-summary
              style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column label="订单ID" width="80" prop="ORDER_ID"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" min-width="270"></el-table-column>
              <el-table-column label="是否过滤关账" v-if="fun_dic[1000305]">
                <template slot-scope="scope">{{ scope.row.FINANCIAL_CLOSING_IGNORE ? '是' : '否' }}</template>
              </el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
              <el-table-column prop="TC_NAME" label="公司" min-width="90"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点" min-width="150"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="100"></el-table-column>
              <el-table-column prop="REAL_TOTAL_WEIGHT" label="总重（KG）" min-width="100"></el-table-column>
              <el-table-column prop="ORDER_LIST_COMMENT" label="订单备注" min-width="90"></el-table-column>
              <el-table-column prop="ORDER_STATUS" label="状态" min-width="140"></el-table-column>
              <el-table-column prop="PRINT_TIME" label="打印次数" min-width="80"></el-table-column>
              <el-table-column prop="ADDED_ORDER" label="订单类型" min-width="80"></el-table-column>
              <el-table-column prop="CATALOG_NAME" label="分类" min-width="100"></el-table-column>
              <el-table-column fixed="right" label="操作" width="190">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="openDetail(scope.row, 3)">查看
                  </el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="singlePDF(scope.row)">导出PDF
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="待供应商客户确认">
          <el-col :span="24">
            <el-table :data="tableData" border stripe style="width: 100%" @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="40"></el-table-column>
              <el-table-column type="index" label="序号" width="50" min-width="30"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号" width="195" min-width="165"></el-table-column>
              <el-table-column label="是否过滤关账" v-if="fun_dic[1000305]">
                <template slot-scope="scope">{{ scope.row.FINANCIAL_CLOSING_IGNORE ? '是' : '否' }}</template>
              </el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期" width="95" min-width="95"></el-table-column>
              <el-table-column prop="GYS_NAME" label="客户"></el-table-column>
              <el-table-column prop="TOTAL_SUPPLIER_FEE" label="总价（元）" min-width="110"></el-table-column>
              <el-table-column prop="TOTAL_WEIGHT" label="总重（KG）" min-width="50"></el-table-column>
              <el-table-column fixed="right" label="操作" width="249">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="() => supplierCusDetail(scope.row, 4)">查看</el-button>
                  <el-button type="text" size="small" @click="output(scope.row)">导出订单
                  </el-button>
                  <el-button type="text" size="small" @click="orderContract(scope.row)">订单资质
                  </el-button>
                  <el-button type="text" size="small" @click="exportCheck(scope.row)">检验报告
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="24" style="text-align: right">
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
              layout="total, prev, pager, next, jumper" :total="totalCount">
            </el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
    </el-row>
    <el-dialog title="选择日期" center :visible.sync="exportTatolDialog" width="600px">
      <el-form :model="exportForm" ref="exportForm" :inline="true">
        <el-form-item label="起始日期">
          <el-date-picker v-model="exportForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="close">取 消</el-button>
        <el-button size="small" @click="submitExportDate">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出PDF模态框 -->
    <el-dialog title="导出PDF" center :visible.sync="pdfFormVisible" width="500px">
      <el-form :model="pdfForm" ref="pdfForm">
        <el-form-item label="是否带价格：">
          <el-radio-group v-model="priceRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否导出实发数量：">
          <el-radio-group v-model="sendCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带实收：">
          <el-radio-group v-model="realCountRadio">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="订单格式：">
          <el-radio-group v-model="docType">
            <el-radio :label="1">全联单</el-radio>
            <el-radio :label="0">半联单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否带供应商抬头">
          <el-radio-group v-model="showSupplierName">
            <el-radio :label="1">带供应商抬头</el-radio>
            <el-radio :label="0">不带供应商抬头</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pdfFormVisible = false">取 消</el-button>
        <el-button @click="submitExport">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 导出合并PDF订单 -->
    <el-dialog title="批量导出" center :visible.sync="exportOrderFormDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="exportMergeForm" ref="exportMergeForm" :rules="rules" label-suffix="："
        label-width="12em">
        <el-form-item label="送货日期" prop="SEND_DAY">
          <el-date-picker v-model="exportMergeForm.SEND_DAY" type="date" placeholder="选择日期" :clearable="false"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="客户" prop="COMPANY">
          <el-select v-model="exportMergeForm.COMPANY" filterable placeholder="请选择" clearable
            @change="queryProjectList">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="门店" prop="PROJECT">
          <el-select v-model="exportMergeForm.PROJECT" filterable placeholder="请选择" clearable>
            <el-option v-for="item in allProjects" :key="item.PROJECT_ID" :label="item.AB_NAME"
              :value="item.PROJECT_ID" />
          </el-select>
        </el-form-item>
        <el-form-item label="是否打印价格">
          <el-radio v-model="exportMergeForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="exportMergeForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否打印送货数量">
          <el-radio v-model="exportMergeForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="exportMergeForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量">
          <el-radio v-model="exportMergeForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="exportMergeForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
        <el-form-item label="是否按品类打印送货单">
          <el-radio v-model="exportMergeForm.CATEGORY_PAGE_FLAG" label="0">否</el-radio>
          <el-radio v-model="exportMergeForm.CATEGORY_PAGE_FLAG" label="1">是</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="exportClose">取 消</el-button>
        <el-button size="small" @click="submitExportOrder('exportMergeForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 单条订单PDF导出 -->
    <el-dialog title="订单打印" center :visible.sync="orderPrintDialog" width="520px" :close-on-click-modal="false">
      <el-form size="small" :model="orderPrintForm" ref="orderPrintForm" :inline="true" :rules="rules">
        <el-form-item label="是否带价格：" label-width='150px'>
          <el-radio v-model="orderPrintForm.printPrice" label="0">不带价格</el-radio>
          <el-radio v-model="orderPrintForm.printPrice" label="1">带价格</el-radio>
        </el-form-item>
        <el-form-item label="是否带送货数量：" label-width='150px'>
          <el-radio v-model="orderPrintForm.printCount" label="0">不带送货数量</el-radio>
          <el-radio v-model="orderPrintForm.printCount" label="1">带送货数量</el-radio>
        </el-form-item>
        <el-form-item label="是否实收数量：" label-width='150px'>
          <el-radio v-model="orderPrintForm.printReal" label="0">不带实收数量</el-radio>
          <el-radio v-model="orderPrintForm.printReal" label="1">带实收数量</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="printClose">取 消</el-button>
        <el-button size="small" @click="submitOrderPrint('printForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改日期模态框 -->
    <el-dialog title="修改送货日期" center :visible.sync="DateVisible" width="400px" @close="closeDate">
      <p style="color: red">此功能请在和客户约定好之后进行使用，慎用！</p>
      <el-form v-model="editDateForm" :ref="editDateForm">
        <el-form-item label="选择目标日期：">
          <el-date-picker v-model="editDateForm.CHSEND_DAY" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align:center">
        <el-button @click="closeDate">取 消</el-button>
        <el-button @click="submitModifyDate">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="修改客户模态框" title="修改客户" width="500px" center>
      <el-form size="medium" :model="修改客户表单" ref="修改客户表单" :inline="true">
        <el-form-item label="客户：" label-width='120px'>
          <el-select @change="(e) => { 修改客户拉取项目点(e) }" style="width: 300px" filterable v-model="修改客户表单.TC_ID"
            placeholder="请选择客户">
            <el-option v-for="item in companys" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目点：" label-width='120px'>
          <el-select @change="(e) => { 修改项目点拉取档口(e) }" style="width: 300px" filterable v-model="修改客户表单.PROJECT_ID"
            placeholder="请选择项目点">
            <el-option v-for="item in 修改客户用项目点列表" :key="item.value" :label="item.PROJECT_NAME" :value="item.PROJECT_ID">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="档口：" label-width='120px'>
          <el-select style="width: 300px" filterable v-model="修改客户表单.DK_ID" placeholder="请选择档口">
            <el-option v-for="item in 修改客户用档口列表" :key="item.ID" :label="item.NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="修改客户模态框 = false">取 消</el-button>
        <el-button size="small" @click="确认修改客户()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  orderConfirmFun, orderConfireSupplierFun, exportConfirmFun, exportAll, exportCheckFun, exportConfirmOrderFun, exportPdfOrder,
  confirmOrderFun, supplierCusConfirmOrder, batchExportFun, selectTCFun, getTCProjectFun, orderPrintFunc, getHaveSupplyRelationshipProjectList,
} from 'api/sellOrder';

import { supplierCusFun } from 'api/customerManage';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';
import validation from '@/assets/common/validation';
import date, { 判断日期范围是否超过限制 } from '@/assets/common/date';
import orderMixin from '@/assets/common/mixins/orderMixin.js';

export default {
  mixins: [orderMixin],
  data () {
    return {
      showOrderType: ['系统下单', '自录订单', '系统下单+自录订单'],
      PAGE_ID: '10003', // 页面ID 一旦规定不要轻易改动
      fun_dic: {
        1000301: 0, 1000302: 0, 1000303: 0, 1000304: 0, 1000305: 0,
      },
      loadSearch: false,
      dkList: [],
      exportTatolDialog: false,
      exportForm: {
        DAY_INTERVAL: [],
      },
      points: [],
      currentPage: 1,
      indexPage: 1,
      totalCount: 0,
      pageSize: 20,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      tableData: [],
      OrderListData: [],
      searchForm: {
        DAY_INTERVAL: [date(new Date().getTime() - 3600 * 1000 * 24 * 31, '%F'), date(new Date(), '%F')],
      },
      pageTitle: '待确认订单列表',
      团餐客户配送类型列表: this.$util.团餐客户配送类型列表,
      pdfFormVisible: false,
      pdfForm: {},
      priceRadio: 1,
      sendCountRadio: 1,
      realCountRadio: 0,
      docType: 1,
      showSupplierName: 1,
      supplierCusOrderData: [],
      currentSupplierPage: 1,
      supplierPageSize: this.pageSize,
      supplierTotalCount: 0,
      currentOrderFlag: 0,
      supplierList: [],
      exportOrderFormDialog: false,
      exportMergeForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
        CATEGORY_PAGE_FLAG: '0',
        PROJECT: '',
      },
      rules: {
        COMPANY: [{ required: true, message: '请选择客户', trigger: 'blur' }],
        SEND_DAY: [{ required: true, message: '请选择送货日期', trigger: 'change' }],
      },
      companys: [],
      allProjects: [],
      orderPrintDialog: false,
      orderPrintForm: {
        printPrice: '0',
        printCount: '0',
        printReal: '0',
      },
      DateVisible: false,
      editDateForm: {},
      stateList: [
        { NAME: '订单已打印', ID: 3 },
        { NAME: '仓管已验收', ID: 4 },
      ],
      checkedArray: [],
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      修改客户模态框: false,
      修改客户表单: {},
      修改客户用项目点列表: [],
      修改客户用档口列表: [],
    };
  },
  mounted () {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_PANENAME) {
      this.searchForm = this.SAVE_PANENAME.CONDITION;
      this.currentPage = this.SAVE_PANENAME.CURRENT_PAGE;
      this.totalCount = this.SAVE_PANENAME.TOTAL_COUNT;
      this.currentOrderFlag = this.SAVE_PANENAME.CURRENT_ORDER_FLAG;

      this.handleCurrentChange();
    } else {
      this.handleSearch();
    }

    this.queryBeforeFun();
    // 下拉框获取项目点名称
    this.queryTitle();
    // 下拉框获取档口名称
    this.__querydkList();
    // 下拉获取供应商客户
    this.querySupplierDataList();
    // 下拉获取团餐客户
    this.queryCustomer();
  },
  computed: {
    // 上一次的搜索结果和条件
    SAVE_PANENAME () {
      return this.$store.state.SAVE_PANENAME;
    },
    isTcCus () {
      return [0, 1, 2].includes(Number(this.currentOrderFlag));
    },
    isSupplierCus () {
      return [3].includes(Number(this.currentOrderFlag));
    },
    isGysConfirm () {
      return [0, 1].includes(Number(this.currentOrderFlag));
    },
    isTcConfirm () {
      return [2].includes(Number(this.currentOrderFlag));
    },
    isSelf () {
      return [1].includes(Number(this.currentOrderFlag));
    },
    批量确认到历史提示 () {
      return this.searchForm.配送类型.toString() == '2' ? '请勾选订单' : '仅全部第三方配送订单可用';
    },
  },
  inject: ['reload'],
  methods: {
    setFinancialClosingIgnore () {
      const params = {
        SERVICE_ID: '10010',
        OTYPE: 20,
        ORDER_ID_LIST: this.checkedArray,
        IS_SUPPLIER_CLIENT: Number(this.isSupplierCus),
      };
      http.post(params).then((_res) => {
        this.$message.show({ text: '标记成功', type: 'success' });
        this.handleCurrentChange();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    确认修改客户 () {
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 103,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.修改客户表单.ORDER_ID,
        TC_ID: this.修改客户表单.TC_ID,
        PROJECT_ID: this.修改客户表单.PROJECT_ID,
        STALL_ID: this.修改客户表单.DK_ID,
      };
      http.post(params).then((res) => {
        this.querySupplierList();
        this.$message.show({ text: '修改成功', type: 'success' });
        this.修改客户表单 = {};
        this.修改客户模态框 = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改项目点拉取档口 (e) {
      if (!this.修改客户表单.PROJECT_ID) {
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECT_ID: e,
      };
      http.post(params).then((result) => {
        this.修改客户用档口列表 = result;
      }).catch((err) => {
        this.$message.show({
          text: err,
          type: 'error',
        });
      });
    },
    修改客户拉取项目点 (e) {
      if (!this.修改客户表单.TC_ID) {
        return false;
      }
      this.修改客户表单.PROJECT_ID = '';
      const params = {
        TC_ID: e,
      };
      getHaveSupplyRelationshipProjectList(params).then((result) => {
        if (result[0]) {
          this.修改客户用项目点列表 = result;
        } else {
          this.修改客户用项目点列表 = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    修改客户 (row) {
      this.修改客户模态框 = true;
      this.修改客户表单.ORDER_ID = row.ORDER_ID;
    },
    // 控制功能按钮
    queryBeforeFun () {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu (e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    // --------------------------------------导出
    exportAllXMD () {
      this.exportTatolDialog = true;
    },
    submitExportDate () {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            START_DATE: this.exportForm.DAY_INTERVAL[0],
            END_DATE: this.exportForm.DAY_INTERVAL[1],
          };
          if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
            params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
          }
          exportAll(params).then((result) => {
            this.$message.show({ text: '导出成功', type: 'success' });
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportTatolDialog = false;
            this.exportForm = {};
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    close () {
      this.exportTatolDialog = false;
      this.exportForm = {};
    },
    queryOrderConfirmListData () {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const data = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.SEND_DAY) {
        data.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.TC_COMPANY) {
        data.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        data.PROJECT_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (this.searchForm.STATUS) {
        data.STATUS = this.searchForm.STATUS;
      }
      if (this.searchForm.PRODUCT_NAME) {
        data.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.dkName) {
        data.DK_ID = this.searchForm.dkName;
      }
      if (this.searchForm.ORDER_ID) {
        data.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        data.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      if (this.searchForm.DAY_INTERVAL) {
        data.START_DAY = this.searchForm.DAY_INTERVAL[0];
        data.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        data.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.ORDER_LIST_COMMENT) {
        data.ORDER_LIST_COMMENT = this.searchForm.ORDER_LIST_COMMENT;
      }
      if (this.searchForm.配送类型 && this.searchForm.配送类型.length) {
        data.DETAIL_TYPE = this.searchForm.配送类型;
      }
      // -------------------------------------------------待项目点确认
      this.loadSearch = true;
      orderConfirmFun(data).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
          this.tableData.forEach((element) => { // tableData你的数据源
            switch (element.ORDER_STATUS) {
              case 1:
                element.ORDER_STATUS = '仓管下单';
                break;
              case 2:
                element.ORDER_STATUS = '档口负责人已确认';
                break;
              case 3:
                element.ORDER_STATUS = '供应商已打印订单';
                break;
              case 4:
                element.ORDER_STATUS = '仓管已验收';
                break;
              case 5:
                element.ORDER_STATUS = '档口负责人已验收';
                break;
              case 6:
                element.ORDER_STATUS = '项目经理已确认';
                break;
              case 301:
                element.ORDER_STATUS = '待项目点确认';
                break;
              default:
                element.ORDER_STATUS = '状态未翻译';
            }
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.loadSearch = false;
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_PANENAME', {
          CONDITION: this.searchForm,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
          CURRENT_ORDER_FLAG: this.currentOrderFlag,
        });
      }).catch((error) => {
        this.loadSearch = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    updateOrderStatus () {
      const params = {
        ORDER_ID: sessionStorage.getItem('orderId'),
      };
      // this.loading = true
      confirmOrderFun(params)
        .then((result) => {
          // this.loading = false
          this.$message.show({ text: '订单确认成功', type: 'success' });
          this.$router.push({ name: 'OrderConfirmList' });
        }).catch((error) => {
          // this.loading = false
          this.$message.show({ text: error, type: 'error' });
        });
    },
    // -----------------------------------------供应商确认，自录订单确认
    querySupplierList () {
      if (this.searchForm.ORDER_ID && !validation.订单ID验证(this.searchForm.ORDER_ID)) {
        this.$message.show({ text: '订单ID只能输入数字', type: 'warning' });
        return false;
      }
      const supplierData = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        STATUS: Number(this.currentOrderFlag) + 1,
      };
      if (this.searchForm.SEND_DAY) {
        supplierData.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.TC_COMPANY) {
        supplierData.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PRODUCT_NAME) {
        supplierData.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.ORDER_ID) {
        supplierData.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        supplierData.PROJECT_ID = JSON.parse(JSON.stringify(this.searchForm.PROJECT));
      }
      if (![null, undefined, ''].includes(this.searchForm.ADDED_ORDER)) {
        supplierData.ADDED_ORDER = this.searchForm.ADDED_ORDER;
      }
      if (this.searchForm.dkName) {
        supplierData.DK_ID = this.searchForm.dkName;
      }
      if ((!this.searchForm.DAY_INTERVAL || !this.searchForm.DAY_INTERVAL.length) && !this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货日期或日期范围', type: 'warning' });
        return;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL.length) {
        if (!判断日期范围是否超过限制(...this.searchForm.DAY_INTERVAL)) {
          supplierData.START_DAY = this.searchForm.DAY_INTERVAL[0];
          supplierData.END_DAY = this.searchForm.DAY_INTERVAL[1];
        } else {
          this.$message.show({ text: '日期范围不能超过31天', type: 'warning' });
          return;
        }
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        supplierData.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.ORDER_LIST_COMMENT) {
        supplierData.ORDER_LIST_COMMENT = this.searchForm.ORDER_LIST_COMMENT;
      }
      if (this.searchForm.配送类型 && this.searchForm.配送类型.length) {
        supplierData.DETAIL_TYPE = this.searchForm.配送类型;
      }
      this.loadSearch = true;
      orderConfireSupplierFun(supplierData).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
          this.tableData.forEach((element) => { // tableData你的数据源
            switch (element.ORDER_STATUS) {
              case 1:
                element.ORDER_STATUS = '仓管下单';
                break;
              case 2:
                element.ORDER_STATUS = '档口负责人已确认';
                break;
              case 3:
                element.ORDER_STATUS = '供应商已打印订单';
                break;
              case 4:
                element.ORDER_STATUS = '仓管已验收';
                break;
              case 5:
                element.ORDER_STATUS = '档口负责人已验收';
                break;
              case 6:
                element.ORDER_STATUS = '项目经理已确认';
                break;
              default:
                element.ORDER_STATUS = '状态未翻译';
            }
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        this.loadSearch = false;
        this.$store.dispatch('SET_SAVE_PANENAME', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
          CURRENT_ORDER_FLAG: this.currentOrderFlag,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.loadSearch = false;
      });
    },
    update (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('ORDER_TC_ID', row.TC_ID);
      this.$router.push({ path: '/selfOrderCheck/detail' });
    },
    // ----------------------------------------------下拉框获取项目点名称
    queryTitle () {
      getHaveSupplyRelationshipProjectList().then((result) => {
        this.points = result.length > 0 ? result : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 选取客户 拉取对应项目点
    queryPROJECT () {
      this.searchForm.PROJECT = [];
      const paramsProject = {
        TC_ID: this.searchForm.TC_COMPANY,
      };
      if (this.searchForm.TC_COMPANY) {
        getHaveSupplyRelationshipProjectList(paramsProject).then((result) => {
          if (result[0]) {
            this.points = result;
          } else {
            this.points = [];
          }
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
      }
    },
    // ----------------------------------------------下拉框获取档口名称
    __querydkList () {
      if (this.searchForm.PROJECT.length === 0) {
        this.dkList = [];
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length != 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      } else {
        this.dkList = [];
        return false;
      }
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleSearch () {
      this.currentPage = 1;
      this.handleCurrentChange();
    },
    // --------------------------------------导出
    output (row) {
      if (document.body.style.cursor === 'wait') {

      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            ORDER_ID: row.ORDER_ID,
          };
          if (this.isSupplierCus) {
            params.IS_SUPPLIER_CLIENT = 1;
          }
          exportConfirmFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally { }
      }
    },
    handleCurrentChange () {
      switch ((this.currentOrderFlag)) {
        case '0':
          this.querySupplierList();
          break;
        case '1':
          this.querySupplierList();
          break;
        case '2':
          this.queryOrderConfirmListData();
          break;
        case '3':
          this.querySupplierCusOrder();
          break;
        default:
          break;
      }
      this.$refs.table.clearSelection();
    },
    orderContract (row) {
      this.$router.push({ name: 'orderContract', params: { id: row.ORDER_ID } });
      sessionStorage.setItem('pageTitle', this.pageTitle);
    },
    exportCheck (row) {
      const params = {
        ORDER_ID: row.ORDER_ID,
      };
      if (this.isSupplierCus) {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      exportCheckFun(params).then((result) => {
        this.$message.show({ text: '导出成功', type: 'success' });
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportAllConfirmOrder () {
      if (!this.searchForm.DAY_INTERVAL) {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      const params = {};
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DATE = this.searchForm.DAY_INTERVAL[0];
        params.END_DATE = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.isSupplierCus) {
        params.IS_SUPPLIER_CLIENT = 1;
        params.THIRD_INFO = 1;
        if (this.searchForm.SUPPLIER) {
          params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
        }
      }

      if (this.isTcCus) {
        if (this.searchForm.TC_COMPANY) params.TC_ID_LIST = [this.searchForm.TC_COMPANY];
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      exportConfirmOrderFun(params).then((result) => {
        if (result[0] && result[0].FILE_PATH) {
          this.$message.show({ text: '导出成功', type: 'success' });
          window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        } else {
          this.$message.show({ text: '无相关数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openDetail (row, flag) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('confirmFlag', flag);
      sessionStorage.setItem('CAN_MODIFY_PRICE', row.CAN_MODIFY_PRICE);
      this.$router.push({ path: '/confirmOrderDetail/detail' });
      if (flag === 2) {
        sessionStorage.setItem('ORDER_TC_ID', row.TC_ID);
      }
      if (flag == 1 || flag == 2) {
        sessionStorage.setItem('orderPrintStatus', 1);
      } else {
        sessionStorage.setItem('orderPrintStatus', 2);
      }
    },
    openExportPDF () {
      if (this.checkedArray.length === 0 && !this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货日期或勾选要导出的订单', type: 'warning' });
      } else if (this.checkedArray.length !== 0 || this.searchForm.SEND_DAY) {
        this.pdfFormVisible = true;
      }
    },
    submitExport () {
      if (this.checkedArray.length !== 0) {
        this.submitExportPdfChecked();
      } else {
        this.submitExportPdf();
      }
    },
    submitExportPdf () {
      if (!this.searchForm.SEND_DAY) {
        this.$message.show({ text: '请选择送货日期', type: 'warning' });
        return;
      }
      const params = {
        PRICE_FLAG: this.priceRadio,
        SEND_COUNT_FLAG: this.sendCountRadio,
        iRCOUNTFlag: this.realCountRadio,
        HALF_PAGE_FLAG: this.docType,
        STATUS: 4,
        START_DAY: this.searchForm.SEND_DAY,
        END_DAY: this.searchForm.SEND_DAY,
        SHOW_SUPPLIER_NAME: this.showSupplierName,
      };
      if (this.searchForm.TC_COMPANY) {
        params.TC_ID = this.searchForm.TC_COMPANY;
      }
      if (this.searchForm.PROJECT && this.searchForm.PROJECT.length !== 0) {
        params.PROJECTS_ID = this.searchForm.PROJECT;
      }
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      exportPdfOrder(params).then((result) => {
        this.$message.show({ text: '导出PDF成功', type: 'success' });
        this.pdfFormVisible = false;
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitExportPdfChecked () {
      const params = {
        SERVICE_ID: '10042',
        OTYPE: 26,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_LIST: this.checkedArray,
        PRICE_FLAG: this.priceRadio,
        SEND_COUNT_FLAG: this.sendCountRadio,
        iRCOUNTFlag: this.realCountRadio,
        HALF_PAGE_FLAG: this.docType,
        SHOW_SUPPLIER_NAME: this.showSupplierName,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '导出PDF成功', type: 'success' });
        this.pdfFormVisible = false;
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySupplierCusOrder () {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        IS_SUPPLIER_CLIENT: 1,
      };
      if (this.searchForm.SEND_DAY) {
        params.SEND_DAY = this.searchForm.SEND_DAY;
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.PRODUCT_NAME) {
        params.PRODUCT_NAME = this.searchForm.PRODUCT_NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      supplierCusConfirmOrder(params).then((result) => {
        if (result.length != 0) {
          this.tableData = result.length > 0 ? result[0].list : [];
          this.totalCount = result.length > 0 ? result[0].TOTAL_COUNT : [];
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
        // 将搜索结果和条件存储到vuex中
        this.$store.dispatch('SET_SAVE_PANENAME', {
          CONDITION: this.searchForm,
          DATA: this.tableData,
          TOTAL_COUNT: this.totalCount,
          CURRENT_PAGE: this.currentPage,
          CURRENT_ORDER_FLAG: this.currentOrderFlag,
        });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    querySupplierDataList () {
      const params = {};
      supplierCusFun(params)
        .then((res) => {
          if (res.length !== 0) {
            this.supplierList = res[0].list;
          } else {
            this.supplierList = [];
          }
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    supplierCusDetail (row) {
      sessionStorage.setItem('orderId', row.ORDER_ID);
      sessionStorage.setItem('orderPrintStatus', 4);
      sessionStorage.setItem('TEM_GYSSCID', row.GYS_ID);
      sessionStorage.setItem('TEM_ISSUPPLIER', 1);
      this.$router.push({ path: '/supplierCusConfirmOrderDetail/detail' });
    },
    queryCustomer () {
      selectTCFun().then((result) => {
        if (result.length !== 0) {
          this.companys = [...new Set(result[0].company.map((item) => JSON.stringify(item)))].map((item) => JSON.parse(item));
        } else {
          this.companys = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryProjectList (e) {
      const paramsProject = {
        TC_ID: e,
      };
      getTCProjectFun(paramsProject).then((result) => {
        if (result[0]) {
          this.allProjects = result;
        } else {
          this.allProjects = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出合并PDF订单
    exportMergeOrder () {
      this.exportOrderFormDialog = true;
    },
    exportClose () {
      this.exportOrderFormDialog = false;
    },
    // 导出合并PDF提交
    submitExportOrder () {
      this.$refs.exportMergeForm.validate((valid) => {
        if (valid) {
          const params = {
            SEND_DAY: this.exportMergeForm.SEND_DAY,
            TC_ID: this.exportMergeForm.COMPANY,
            PRICE_FLAG: Number(this.exportMergeForm.printPrice),
            ORDER_FLAG: 1,
            SEND_COUNT_FLAG: Number(this.exportMergeForm.printCount),
            iRCOUNTFlag: Number(this.exportMergeForm.printReal),
            CATEGORY_PAGE_FLAG: Number(this.exportMergeForm.CATEGORY_PAGE_FLAG),
          };
          if (this.exportMergeForm.PROJECT !== '') {
            params.PROJECT_ID = this.exportMergeForm.PROJECT;
          }
          if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
            params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
          }
          batchExportFun(params).then((result) => {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
            this.exportOrderFormDialog = false;
            this.$nextTick(() => {
              this.$refs.exportMergeForm.resetFields();
            });
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } else {
          return false;
        }
      });
    },
    // 单条订单导出PDF
    singlePDF (row) {
      this.orderPrintDialog = true;
      this.orderPrintForm.ORDER_ID = row.ORDER_ID;
    },
    printClose (formName) {
      this.$nextTick(() => {
        this.$refs.printForm.resetFields();
      });
      this.printFormDialog = false;
      this.orderPrintDialog = false;
    },
    submitOrderPrint () {
      const params = {
        PRICE_FLAG: Number(this.orderPrintForm.printPrice),
        ORDER_ID: this.orderPrintForm.ORDER_ID,
        SEND_COUNT_FLAG: Number(this.orderPrintForm.printCount),
        iRCOUNTFlag: Number(this.orderPrintForm.printReal),
      };
      orderPrintFunc(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
        this.orderPrintDialog = false;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 打开修改日期模态框
    openDateDia (row) {
      this.ORDER_ID_DATE = row.ID ? row.ID : row.ORDER_ID;
      this.DateVisible = true;
    },
    // 关闭修改日期模态框
    closeDate () {
      this.DateVisible = false;
      this.editDateForm = {};
    },
    // 修改日期
    submitModifyDate () {
      // 关账限制
      if (this.$util.isOrderClosed(this.editDateForm.CHSEND_DAY)) {
        this.$message.show({ text: '该月份已关账，无法修改为此日期', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 45,
        ORDER_ID: Number(this.ORDER_ID_DATE),
      };
      if (this.editDateForm.CHSEND_DAY) {
        params.CHSEND_DAY = this.editDateForm.CHSEND_DAY;
      } else {
        this.$message.show({ text: '请选择日期', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.querySupplierList();
        this.DateVisible = false;
        this.editDateForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 单元格合计
    getSummaries (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property === 'REAL_TOTAL_SUPPLIER_FEE' || column.property === 'REAL_TOTAL_WEIGHT') {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + Math.floor((value) * 100) / 100;
            }
            return prev;
          }, 0).toFixed(2);
        }
      });
      this.sums = sums;
      return sums;
    },
    handleSelectionChange (val) {
      this.checkedArray = val.map((item) => item.ORDER_ID);
    },
    async batchChangeToHistory () {
      const errorList = [];
      for (const ORDER_ID of this.checkedArray) {
        try {
          await confirmOrderFun({ ORDER_ID });
        } catch (err) {
          errorList.push(ORDER_ID);
        }
      }
      if (errorList.length) {
        this.$message.show({ text: `ID为${errorList.join('、')}的订单转换状态失败`, type: 'error' });
      } else {
        this.$message.show({ text: '批量确认成功', type: 'success' });
      }
      this.handleSearch();
    },
  },
};
</script>

<style scoped>
/* 作用于本页面所有 dialog 内的表单控件：el-dialog 渲染在本组件内，
   vue-loader 13 只支持单个 >>>，编译后为 .el-dialog__wrapper[data-v-xxx] .el-dialog ...，
   scoped 保证不影响其他页面，不新增类 */
.el-dialog__wrapper>>>.el-select,
.el-dialog__wrapper>>>.el-autocomplete,
.el-dialog__wrapper>>>.el-input,
.el-dialog__wrapper>>>.el-date-editor {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/OrderConfirmList.vue